var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-page"},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":"My SVG Image"}}),_c('h2',[_vm._v("You don't have permission to access this feature")]),_c('button',{staticClass:"blue-button",on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("Click here to continue")])])
}
var staticRenderFns = []

export { render, staticRenderFns }